module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.f80816a.ttf";